export const FOOTER_BUTTON_DEFAULT_PROPS = {
    size: "medium",
    width: "130px"
};